import { render, staticRenderFns } from "./sla.vue?vue&type=template&id=8c5d71ea"
import script from "./sla.vue?vue&type=script&lang=js"
export * from "./sla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports